import api from './api';

export const categoryService = {
  getAll: async () => {
    const res = await api.get('/Category/GetAll');
    return res.data.data;
  },

  getBySlug: async (slug) => {
    const res = await api.get(`/Category/GetBySlug/${slug}`);
    return res.data.data;
  },
};
